import { format, parseISO } from 'date-fns';
import { Event } from '../../../../services';
import { getDateFnsLocale } from '../../../utils';
import { getEventDateTimeFormat } from './getEventDateTimeFormat';

export const eventRegistrationDeadline = (
  event: Pick<Event, 'startAt' | 'participantsRegistrationDeadlineEndAt'>
): string => {
  const { startAt, participantsRegistrationDeadlineEndAt } = event;

  return format(
    participantsRegistrationDeadlineEndAt
      ? parseISO(participantsRegistrationDeadlineEndAt)
      : parseISO(startAt),
    getEventDateTimeFormat(),
    { locale: getDateFnsLocale() }
  );
};
